<template>
    <div class="content-page">
        <publicHeader></publicHeader>
        <transition name="router-slide" mode="out-in">
            <router-view v-wechat-title="$route.name"></router-view>
        </transition>
        <scrollTop></scrollTop>
        <publicFooter></publicFooter>
    </div>
</template>

<script>
	import Vue from 'vue'
    import { CONFIG,network } from '@assets/js/apis';
    import publicHeader from '@components/header';
    import publicFooter from '@components/footer';
    import scrollTop from '@components/scrollTop';
    export default {
		data() {
			return {
               
			}
        },
        components: {
            publicHeader,
            publicFooter,
            scrollTop
		},
        created(){
        },
        mounted: function() {
           
        },
        methods:{
        }
    }
</script>

<style lang="scss">
    @import '~@assets/css/style';
    .content-page{
        padding-top: 74px;
    }
    .router-fade-enter-active, .router-fade-leave-active {
        transition: opacity .2s;
    }
    .router-fade-enter, .router-fade-leave-active {
        opacity: 0;
    }
    // .router-slide-enter-active, .router-slide-leave-active {
	//     transition: all .2s;
	// }
	// .router-slide-enter, .router-slide-leave-active {
	//     transform: translate3d(2rem, 0, 0);
	//     opacity: 0;
    // }
    .router-slide-enter-active {
	    transition: all 0.2s;
	}
	.router-slide-enter{
        transform: translate3d(-2em, 0, 0);
	}
</style>



// WEBPACK FOOTER //
// src/pages/content/content.vue